import {scroller} from './scroller';
export function localNavInboundScroll() {
  if($('.js-local-nav')[0]) {
    const $localNavElement = $('.js-local-nav').find('.js-local-nav-element');
    const $sectionScrollTarget = $('.js-section-scroll-target');
    const $scrollNavPlaceholder = $('.js-scroll-nav-placeholder');
    let contentsArr = '';

    const CONTENT_POSITION = function() {
      contentsArr = new Array;
      let i = 0;
      const results = [];
      while (i <= $localNavElement.length - 1) {
        const target = $sectionScrollTarget.eq(i);
        const targetContentOffset = target.offset();
        let targetContentTop = '';
        targetContentTop = targetContentOffset.top - $scrollNavPlaceholder.height() - 1;
        const targetContentBottom = targetContentTop + target.outerHeight(true);
        contentsArr[i] = [targetContentTop, targetContentBottom];
        results.push(i++);
      }
      return results;
    };
    
    const POSITION_CHECK = function() {
      const $scTop = $(window).scrollTop();
      let i = 0;
      let fire = false;
      while (i <= contentsArr.length - 1) {
        if (contentsArr[i][0] <= $scTop && contentsArr[i][1] >= $scTop) {
          fire = true;
          $localNavElement.removeClass('is-current');
          $localNavElement.eq(i).addClass('is-current');
          i === contentsArr.length;
        }
        i++;
      }
      if (!fire) $localNavElement.removeClass('is-current');
    };

    const INBOUND_SCROLL = function() {
      $localNavElement.on('click', function() {
        $('body,html').stop();
        const i = $localNavElement.index(this);
        const target = $sectionScrollTarget.eq(i);
        const targetOffset = target.offset();
        let targetTop = '';

        if($(window).width() >= 768) {
          if(IS_TOUCH) {
            targetTop = targetOffset.top;
          } else {
            targetTop = targetOffset.top - $scrollNavPlaceholder.height();
          }
        } else {
          targetTop = targetOffset.top - $scrollNavPlaceholder.height();
        }

        scroller(targetTop, 1200, 'easeInOutExpo');
        setTimeout(function() {
          $(window).trigger('scroll.peekaboo');
        }, 1200);
      });
    };

    CONTENT_POSITION();
    POSITION_CHECK();
    INBOUND_SCROLL();
    $(window).on('load debouncedresize', CONTENT_POSITION);
    $(window).on('load debouncedscroll', POSITION_CHECK);
  }
}